module.exports = __webpack_public_path__ + "static/img/ok_icon.921b120.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/view10/ok_icon.png
// module id = UNyV
// module chunks = 1